import React, { useState, useEffect } from 'react';
import './EmpresaN.css';
import { setMenu } from '../actions/index';
import { useDispatch } from 'react-redux';
import { updateCompany } from './general/api'; // Importar la función desde api.js

const EmpresaUpdate = ({ companyData }) => {
  const dispatch = useDispatch();

  // Estado para almacenar los datos del formulario
  const [formData, setFormData] = useState({
    id: '',
    name_emp: '',
    nit_emp: '',
    address_emp: '',
    phone_emp: '',
    email_emp: '',
    website_emp: '',
    expire_date_emp: '',
    picture_emp: null,
  });

  // UseEffect para sincronizar los datos al cargar o actualizar `companyData`
  useEffect(() => {
    // Verificar si `companyData` es un arreglo y tiene al menos un objeto
    if (Array.isArray(companyData) && companyData.length > 0) {
      const company = companyData[0]; // Obtener el primer objeto del arreglo
      setFormData({
        id: company.Id_Empresa || '',
        name_emp: company.Name_Emp || '',
        nit_emp: company.Nit_Emp || '',
        address_emp: company.Adress_Emp || '',
        phone_emp: company.Tel_Emp || '',
        email_emp: company.Email_Emp || '',
        website_emp: company.Website_Emp || '',
        expire_date_emp: company.Expiry_Date_Emp || '',
        picture_emp: null, // Mantener este campo vacío si no se actualiza
      });
    }
  }, [companyData]); // Escuchar cambios en `companyData`

  // Manejo de cambios en los campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      picture_emp: e.target.files[0],
    }));
  };

  // Enviar datos actualizados
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await updateCompany(formData); // Llama a la API
      console.log(response); // Imprime la respuesta de la API
      alert('Empresa actualizada con éxito');
      dispatch(setMenu('empresaAct')); // Navegar al menú de empresas
    } catch (error) {
      console.error(error);
      alert('Ocurrió un error al actualizar la empresa');
    }
  };

  // Mostrar un mensaje de carga si `companyData` es un arreglo vacío
  if (!Array.isArray(companyData) || companyData.length === 0) {
    return <p>Cargando los datos de la empresa...</p>;
  }

  return (
    <div className="empresaN">
      <h2>Actualizar Empresa</h2>
      <form onSubmit={handleSubmit}>
        <label>
          Nombre de la Empresa:
          <input
            type="text"
            name="name_emp"
            value={formData.name_emp}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          NIT:
          <input
            type="text"
            name="nit_emp"
            value={formData.nit_emp}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Dirección:
          <input
            type="text"
            name="address_emp"
            value={formData.address_emp}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Teléfono:
          <input
            type="text"
            name="phone_emp"
            value={formData.phone_emp}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Correo Electrónico:
          <input
            type="email"
            name="email_emp"
            value={formData.email_emp}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Sitio Web:
          <input
            type="url"
            name="website_emp"
            value={formData.website_emp}
            onChange={handleChange}
          />
        </label>
        <label>
          Fecha de Expiración:
          <input
            type="date"
            name="expire_date_emp"
            value={formData.expire_date_emp}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Logo de la Empresa:
          <input type="file" name="picture_emp" onChange={handleFileChange} />
        </label>
        <button type="submit">Actualizar Empresa</button>
      </form>
    </div>
  );
};

export default EmpresaUpdate;
